module.exports = __webpack_public_path__ + "img/banner.40cc7188.png";